import { localizeRoute, type LOCALIZED_PATHS } from '../constants/url-constants';

type AppLocale = keyof typeof LOCALIZED_PATHS;

/** English logical hosted-careers-page path (`urlLogical` / Vike filesystem) — TEC-488. */
export function careersPageLogicalPath(companyId: string): string {
  const id = String(companyId ?? '').trim();
  return `/careers/${encodeURIComponent(id)}`;
}

/** Full public path with locale prefix and localized segment (`/fi/ura/…`, `/sv/karriar/…`). */
export function careersPageUrlPath(locale: AppLocale, companyId: string): string {
  const logical = careersPageLogicalPath(companyId);
  return `/${locale}${localizeRoute(logical, locale)}`;
}
